export default __webpack_public_path__ + "static/media/reports.c643fd1b.svg";